import { IMeta, IPagination, ISort } from "@delanobgt/admin-core/util/types";
import { produce } from "immer";
import { Reducer } from "redux";
import {
  EGuideDetailTypeSortField,
  IGuideDetailType,
  PGuideDetailTypeFilter,
} from "src/core/guideDetailType/entities";
import { ActionType, createAction, getType } from "typesafe-actions";

/*
 * state
 */
export interface IGuideDetailTypeState {
  guideDetailTypes: IGuideDetailType[];
  loading: boolean;
  error: any;
  meta: IMeta;
}

const initialState: IGuideDetailTypeState = {
  guideDetailTypes: [],
  loading: false,
  error: null,
  meta: {
    limit: 10,
    offset: 0,
    total: 0,
  },
};

/*
 * action types
 */
const FETCH_REQUESTED = "guide-detail-type/FETCH_REQUESTED";
const FETCH_SUCCEEDED = "guide-detail-type/FETCH_SUCCEEDED";
const FETCH_FAILED = "guide-detail-type/FETCH_FAILED";
const POLLING_START_REQUESTED = "guide-detail-type/POLLING_START_REQUESTED";
const POLLING_STOP_REQUESTED = "guide-detail-type/POLLING_STOP_REQUESTED";

/*
 * action creators
 */
export const actions = {
  fetchRequested: createAction(FETCH_REQUESTED)(),

  fetchSucceeded: createAction(FETCH_SUCCEEDED)<{
    data: IGuideDetailType[];
    meta: IMeta;
  }>(),

  fetchFailed: createAction(FETCH_FAILED)<any>(),

  pollingStartRequested: createAction(POLLING_START_REQUESTED)<{
    filter: PGuideDetailTypeFilter;
    pagination: IPagination;
    sorts: ISort<EGuideDetailTypeSortField>[];
    refreshDelay: number;
  }>(),

  pollingStopRequested: createAction(POLLING_STOP_REQUESTED)(),
};
export type TActions = ActionType<typeof actions>;

const reducer: Reducer<IGuideDetailTypeState, TActions> = (
  state = initialState,
  action
) => {
  return produce<IGuideDetailTypeState>(state, (draft) => {
    switch (action.type) {
      case getType(actions.fetchRequested): {
        draft.loading = true;
        draft.error = null;
        break;
      }
      case getType(actions.fetchSucceeded): {
        const {
          payload: { data, meta },
        } = action;
        draft.guideDetailTypes = data;
        draft.loading = false;
        draft.error = null;
        draft.meta = meta;
        break;
      }
      case getType(actions.fetchFailed): {
        const { payload } = action;
        draft.loading = false;
        draft.error = payload;
        break;
      }
    }
  });
};

export default reducer;
